import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  margin: 0; // 1rem 3% 0px 3%;
  #header-top {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
    align-content: center;
    #header-tab-personal {
      position: relative;
      width: max-content;
      padding: 0px;
      text-align: center;
      color: var(--color-white);
      background-color: #8b151b;
      #header-tab-title-personal {
        width: max-content;
        font-size: 1.8rem;
        padding: 0.5rem 1.5rem;
      }
      &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translate(-50%);
        width: 0;
        height: 0;
        border-top: solid 8px #8b151b;
        border-left: solid 8px transparent;
        border-right: solid 8px transparent;
      }
    }
    #header-tab-corporate {
      width: max-content;
      padding: 0px;
      text-align: center;
      font-size: 1.8rem;
      color: var(--color-white);
      background-color: var(--color-brick);
      #header-tab-title-corporate {
        width: max-content;
        font-size: 1.8rem;
        padding: 0.5rem 1.5rem;
      }
      #header-tab-dropdown-corporate {
        position: fixed;
        right: -100%;
      }
      &:hover {
        position: relative;
        background-color: #eeeeee;
        #header-tab-title-corporate {
          color: var(--color-black);
        }
        #header-tab-dropdown-corporate {
          position: absolute;
          cursor: default;
          right: 0px;
          z-index: 1;
          width: max-content;
          background-color: var(--color-white);
          box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
          #hsc-main {
            display: flex;
            flex-direction: row;
            align-items: stretch;
            justify-content: center;
            align-content: center;
            & > div {
              border: none;
              margin: 0px;
              padding: 2rem;
              display: flex;
              flex-direction: column;
              align-items: stretch;
              justify-content: flex-start;
              align-content: center;
              row-gap: 0.5rem;
              & > .slc-title {
                text-align: left;
              }
              & > .slc-links-container {
                display: flex;
                flex-direction: column;
                align-items: stretch;
                justify-content: center;
                align-content: center;
                row-gap: 1rem;
              }
            }
            & > div:nth-child(even) {
              background-color: #eeeeee;
            }
          }
        }
        #hdb-chevron-down {
          display: unset;
        }
        #hdb-chevron-up {
          display: none;
        }
        &:hover {
          #hdb-chevron-down {
            display: none;
          }
          #hdb-chevron-up {
            display: unset;
          }
        }
      }
    }
    #header-tab-advisor {
      width: max-content;
      padding: 0px;
      text-align: center;
      font-size: 1.8rem;
      color: var(--color-white);
      background-color: var(--color-brick);
      #header-tab-title-advisor {
        width: max-content;
        font-size: 1.8rem;
        padding: 0.5rem 1.5rem;
      }
      #header-tab-dropdown-advisor {
        position: fixed;
        right: -100%;
      }
      &:hover {
        position: relative;
        background-color: #eeeeee;
        #header-tab-title-advisor {
          color: var(--color-black);
        }
        #header-tab-dropdown-advisor {
          position: absolute;
          cursor: default;
          right: 0px;
          z-index: 1;
          width: max-content;
          background-color: var(--color-white);
          box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
          #hsa-main {
            display: flex;
            flex-direction: row;
            align-items: stretch;
            justify-content: center;
            align-content: center;
            & > div {
              border: none;
              margin: 0px;
              padding: 2rem;
              display: flex;
              flex-direction: column;
              align-items: stretch;
              justify-content: flex-start;
              align-content: center;
              row-gap: 0.5rem;
              & > .slc-title {
                text-align: left;
              }
              & > .slc-links-container {
                display: flex;
                flex-direction: column;
                align-items: stretch;
                justify-content: center;
                align-content: center;
                row-gap: 1rem;
              }
            }
            & > div:nth-child(even) {
              background-color: #eeeeee;
            }
          }
        }
        #hdb-chevron-down {
          display: unset;
        }
        #hdb-chevron-up {
          display: none;
        }
        &:hover {
          #hdb-chevron-down {
            display: none;
          }
          #hdb-chevron-up {
            display: unset;
          }
        }
      }
    }
  }
  #header-main {
    background-color: var(--color-brick);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 1.5rem 2.2rem;
    #header-logo-container {
      #header-logo {
        align-items: center;
        cursor: pointer;
        width: auto;
        height: 35px;
        flex-grow: 1;
      }
    }
    #header-dropdown-container {
      justify-self: stretch;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      height: fit-content;
      margin-left: 2rem;
      flex-grow: 5;
    }
    #header-login {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      height: fit-content;
      flex-grow: 1;
      .header-item-with-icon {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 1.6rem;
        color: var(--color-white);
        width: fit-content;
        padding: 0.5rem;
        text-decoration: none;
        border: none;
        background-color: transparent;
        border-bottom: 1.5px solid var(--color-brick);
        & > div:first-child {
          margin-right: 0.5rem;
        }
        &.hover-underline:hover {
          border-bottom: 1.5px solid white;
        }
      }
    }
  }
  #header-middle {
    background-color: var(--color-tan_two);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0rem 2.2rem;
    #header-title-container {
      font-size: 1.6rem;
      color: var(--color-white);
      width: 150px;
    }
    #header-dropdown-container {
      justify-self: stretch;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      height: fit-content;
      margin-left: 2rem;
      flex-grow: 5;
    }
  }
  #header-bottom {
    background-color: var(--color-dirt_brown);
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 1rem 2.2rem;
    #header-title-container {
      font-size: 1.6rem;
      color: var(--color-white);
      width: 100%;
    }
  }
  #header-sidebar {
    position: absolute;
    z-index: 9999;
    top: 0px;
    right: 0px;
    margin-left: auto;
    width: 100%;
    max-width: 300px;
    height: 100vh;
    overflow-y: scroll;
  }
  @media (max-width: 991px) {
    margin: 0px 0px 0px 0px;
    #header-main {
      justify-content: flex-start;
      #header-dropdown-container {
        display: none;
      }
      #header-login {
        .fa-icon-container {
          padding: 1rem;
          margin-left: 1rem;
          border-bottom: none;
          .fa-icon {
            font-size: 2rem;
          }
        }
      }
    }
    #header-top {
      display: none;
    }
    #header-middle {
      display: none;
      justify-content: flex-start;
      #header-dropdown-container {
        display: none;
      }
    }
    #header-bottom {
      display: none;
    }
  }
`;
